// extracted by mini-css-extract-plugin
export default {"globalTitle":"MainPage_globalTitle__n89oC","video":"MainPage_video__VNCT3","countersWrapper":"MainPage_countersWrapper__hc1Ag","counters":"MainPage_counters__p1oct"};